import React, {useEffect, useState} from "react";
import "./InstallationParameters.css";
import {Link, useLocation, useParams} from "react-router-dom";
import {useIntl} from "react-intl";
import API, {Resolution} from "../../../logic/API";
import chevron from "../../../resources/icons/chevron-left.svg";
import {
  AvailableAppParametersResponse,
  InstallationLocationState,
} from "../../../logic/APITypes";
import ParameterForm from "./ParameterForm";
import {LoadingSkeleton} from "@spg/component_library";
import useAppActions from "../../../hooks/useAppActions";
import useInitialAppStatus from "../../../hooks/useInitialAppStatus";

/** A page that fetches parameters required for the installation of an app, embeds the resulting form and initiates the resulting installation */
function InstallationParameters() {
  const {formatMessage} = useIntl();
  const {state}: {state: null | InstallationLocationState} = useLocation();
  let {groupId, appId} = useParams();
  groupId = groupId || "";
  appId = appId || "";
  const {installApp, loadingStates} = useAppActions(groupId);

  const {loadingStates: initialLoadingStates} = useInitialAppStatus({
    groupId,
    apps: [{appId, isInstalled: false}],
  });

  const [parameters, setParameters] = useState<
    Resolution<AvailableAppParametersResponse>
  >({
    unresolved: true,
    success: false,
  });

  useEffect(() => {
    API.getAppParameters(groupId, appId).then((response) =>
      setParameters(response),
    );
  }, []);

  return (
    <div className="installationParameters">
      <h1 className="installationParameters__heading">
        <Link
          to={
            `/groups/${groupId}` +
            (state?.from === "group" ? "" : `/apps/available/${appId}`)
          }
        >
          <img
            src={chevron}
            alt={formatMessage({
              id: "general.button.label.back",
            })}
          />
        </Link>
        {parameters.payload
          ? formatMessage(
              {
                id: "appInstallationParameters.installationParameters.heading.named",
              },
              {appName: parameters.payload.name},
            )
          : formatMessage({
              id: "appInstallationParameters.installationParameters.heading",
            })}
      </h1>
      <p
        className={`installationParameters__paragraph${parameters.errorReason ? " installationParameters__paragraph--error" : ""}`}
      >
        {formatMessage(
          {
            id: parameters.errorReason
              ? "appInstallationParameters.installationParameters.paragraph.error"
              : "appInstallationParameters.installationParameters.paragraph",
          },
          {
            br: <br />,
          },
        )}
      </p>
      {parameters.payload && (
        <ParameterForm
          schema={parameters.payload.json_schema}
          onValidSubmission={(submission) => {
            installApp(appId, submission);
          }}
          loading={loadingStates[appId] || initialLoadingStates[appId]}
        />
      )}
      {parameters.unresolved && (
        <div className="installationParameters__loading">
          <LoadingSkeleton width="100%" height="48px" />
          <LoadingSkeleton width="100%" height="48px" />
          <LoadingSkeleton width="25%" height="32px" />
        </div>
      )}
    </div>
  );
}

export default InstallationParameters;
